// import CustomizeDashboardIcon from "../../assets/icons/customize_dashboard_icon.svg";
import UploadIcon from "../../assets/icons/upload_icon.svg";
import Button from "../Buttons";
import { CONSTANTS } from "../../constants/Constants";
import Input from "../Inputs";
import { ThemePayloadProps } from "../../pages/DashboardSetup";
import crossIcon from '../../assets/icons/cross_icon.svg'
import CustomizeDashboardIcon from "../../assets/svgcomps/CustomizeDashboardIcon";
import LoadSpinner from "../LoadingSpinner";
interface CustomizeProps {
  continueHandler?: () => void;
  skipHandler?: () => void
  themeChangeHandler?: (e: any) => void
  themePayload?: ThemePayloadProps
  isLoading?: boolean
  reference: any
  isLogoRequired?: boolean
}
const CustomizeDashboard = ({ continueHandler, skipHandler, themeChangeHandler, themePayload, isLoading, reference, isLogoRequired }: CustomizeProps) => {
  
  return (
    <div className="w-full max-w-md">
      {/* Header */}
      <div className="mb-6 flex items-center">
        <div className="w-[48px] h-[48px]">
          <CustomizeDashboardIcon
            fill={themePayload?.PrimaryColor}
          />
        </div>
        <h2 className={`text-[24px] font-semibold text-primary ml-3`}>
          {CONSTANTS.LETS_SETUP_DASHBOARD_TXT}
        </h2>
      </div>

      {/* Logo Upload */}
      <div className="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center mb-6">
        <div className="text-gray-500">
          {themePayload?.CompanyLogo && <div className="relative cursor-pointer hover: z-10" onClick={themeChangeHandler}>
            <span className="absolute w-3 top-2 right-0 center inline-block">
              <img src={crossIcon} alt="icon" aria-label="cross" />
            </span>
          </div>}
          <label htmlFor="logo-upload" className="cursor-pointer">
            {themePayload?.CompanyLogo ? (
              <div
                className="flex justify-center h-[75px]"
              >
                <img
                  src={URL.createObjectURL(themePayload?.CompanyLogo)}
                  alt={themePayload?.CompanyLogo.name}
                />
              </div>
            ) : (
              <>
                <span className="text-2xl flex justify-center">
                  <img src={UploadIcon} alt="icon" />
                </span>
                <p className="mt-2 font-medium">{CONSTANTS.UPLOAD_COMPANY_LOGO_TXT}</p>
                <p className="text-sm text-gray-400">
                  {CONSTANTS.DRAG_N_DROP_FILE_TXT}
                </p>
              </>
            )}
          </label>
        </div>
        <Input
          id="logo-upload"
          type="file"
          other_classes="hidden"
          change_handler={themeChangeHandler}
          accept="image/*"
          input_name={CONSTANTS.PAYLOAD_KEYS.BRANDING_PAYLOAD_KEYS.COMPANY_LOGO}
          reference={reference}
        />
      </div>

      {/* Color Inputs */}
      {[
        {
          label: CONSTANTS.PRIMARY_COLOR,
          input_name: CONSTANTS.PAYLOAD_KEYS.BRANDING_PAYLOAD_KEYS.PRIMARY_COLOR,
          color: themePayload?.PrimaryColor,
          changeHandler: themeChangeHandler
        },
        {
          label: CONSTANTS.SECONDARY_COLOR,
          input_name: CONSTANTS.PAYLOAD_KEYS.BRANDING_PAYLOAD_KEYS.SECONDARY_COLOR,
          color: themePayload?.SecondaryColor,
          changeHandler: themeChangeHandler
        },
        {
          label: CONSTANTS.TERTIARY_COLOR,
          input_name: CONSTANTS.PAYLOAD_KEYS.BRANDING_PAYLOAD_KEYS.TERTIARY_COLOR,
          color: themePayload?.TertiaryColor,
          changeHandler: themeChangeHandler
        },
      ].map(({ label, color, input_name, changeHandler }, index) => {
        return (
          <div key={index} className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              {label} *
            </label>
            <div className="relative flex items-center">
              <Input
                type="text"
                input_name={input_name}
                value={color}
                change_handler={changeHandler}
                other_classes="w-full border rounded-md p-2 pr-12 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-green-500"
              />
              <input
                name={input_name}
                type="color"
                value={color}
                onChange={changeHandler}
                className="absolute right-2 top-1/2 transform -translate-y-1/2 !w-8 !h-8 border border-gray-300 !rounded-md cursor-pointer"
              />
            </div>
          </div>
        )
      })}

      {/* Buttons */}
      <div className="flex justify-end gap-3 mt-6">
        <div className="w-[120px]">
          <Button
            on_click_handler={skipHandler}
            btn_label="Skip"
            other_classes="!bg-transparent border border-gray-300 !text-black hover:!bg-gray-100"
          />
        </div>
        <div className="w-[120px] relative">
          {isLoading && <LoadSpinner
            classes="absolute top-0"
          />}
          <Button
            on_click_handler={continueHandler}
            btn_label={CONSTANTS.CONTINUE_TXT}
            is_disable={isLoading || (!themePayload?.CompanyLogo && isLogoRequired)}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomizeDashboard;
